module.exports = __webpack_public_path__ + "static/img/行驶.bd84caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/电力工程车/行驶.png
// module id = P6W/
// module chunks = 76